<template>
  <div
    :class="[
      $style.divider,
      {
        [$style.divider__label]: props.label,
        [$style.divider__solid]: props.type === 'solid',
        [$style.divider__dashed]: props.type === 'dashed',
      },
    ]"
  >
    <template v-if="label">
      {{ label }}
    </template>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  label?: string;
  type?: "solid" | "dashed";
}

const props = withDefaults(defineProps<Props>(), {
  label: "",
  type: "solid",
});
</script>

<style lang="scss" module>
.divider {
  @apply flex items-center text-neutral-600;

  &__solid {
    &:before,
    &:after {
      @apply bg-neutral-500 flex-grow;
      content: "";
      height: 1px;
    }
  }

  &__dashed {
    &:before,
    &:after {
      @apply border-t border-neutral-500 border-dashed flex-grow;
      content: "";
    }
  }

  &__label {
    &:before {
      @apply mr-3;
    }

    &:after {
      @apply ml-3;
    }
  }
}
</style>
